module.exports = __webpack_public_path__ + "media/react/gmat/organisms/official_practice_tests_card/practice_exams_3_4-fad04ec1a839ac34cebb38f09a60536b.png";